module.exports = __webpack_public_path__ + "img/kwai.bc37959b.svg";